import { _s } from '@/locale';
import { PaymentMethodListItem } from '@/types/checkout';
import { PaymentCard } from '@/types/paymentcards';

const getBaseTranslationKey = (isCheckoutRedesign: boolean) =>
  isCheckoutRedesign ? 'constants.checkoutRedesign' : 'constants.checkout';

export const CHECKOUT_PAYMENT_METHOD = {
  NONE: -1,
  PAY_AT_PLACE: 0,
  KLARNA: 1,
  QLIRO: 3,
  STORED_COF: 4,
  NEW_COF: 5,
  GOOGLE_PAY: 6,
  APPLE_PAY: 7,
  SWISH: 8,
} as const;

export const COUPON_PAYMENT_METHOD = {
  GIFTCARD: 'GIFTCARD',
  VALUECARD: 'VALUECARD',
  WELLNESSCARD: 'WELLNESSCARD',
} as const;

const paymentListItem = (
  key: string,
  type: any,
  isCheckoutRedesign: boolean = false,
  onlinePaymentRequired?: boolean,
): PaymentMethodListItem => {
  const baseTranslationKey = getBaseTranslationKey(isCheckoutRedesign);
  return {
    title: _s(`${baseTranslationKey}.${key}.title`),
    subTitle:
      typeof onlinePaymentRequired === 'boolean'
        ? _s(`${baseTranslationKey}.${key}.${onlinePaymentRequired ? 'subTitleOnlinePaymentRequired' : 'subTitle'}`)
        : _s(`${baseTranslationKey}.${key}.subTitle`),
    type,
  };
};

export const NEW_ONLINE_CARD_LIST_ITEM = (isCheckoutRedesign: boolean = false): PaymentMethodListItem =>
  paymentListItem('NEW_ONLINE_CARD_LIST_ITEM', CHECKOUT_PAYMENT_METHOD.NEW_COF, isCheckoutRedesign, true);

export const APPLE_PAY_LIST_ITEM = (isCheckoutRedesign: boolean = false): PaymentMethodListItem =>
  paymentListItem('APPLE_PAY_LIST_ITEM', CHECKOUT_PAYMENT_METHOD.APPLE_PAY, isCheckoutRedesign, true);

export const GOOGLE_PAY_LIST_ITEM = (isCheckoutRedesign: boolean = false): PaymentMethodListItem =>
  paymentListItem('GOOGLE_PAY_LIST_ITEM', CHECKOUT_PAYMENT_METHOD.GOOGLE_PAY, isCheckoutRedesign, true);

export const KLARNA_LIST_ITEM = (
  isCheckoutRedesign: boolean = false,
  onlinePaymentRequired: boolean = false,
): PaymentMethodListItem =>
  paymentListItem('KLARNA_LIST_ITEM', CHECKOUT_PAYMENT_METHOD.KLARNA, isCheckoutRedesign, onlinePaymentRequired);

export const QLIRO_LIST_ITEM = (
  isCheckoutRedesign: boolean = false,
  onlinePaymentRequired: boolean = false,
): PaymentMethodListItem =>
  paymentListItem('QLIRO_LIST_ITEM', CHECKOUT_PAYMENT_METHOD.QLIRO, isCheckoutRedesign, onlinePaymentRequired);

export const PAY_AT_PLACE_LIST_ITEM = (isCheckoutRedesign: boolean = false): PaymentMethodListItem =>
  paymentListItem('PAY_AT_PLACE_LIST_ITEM', CHECKOUT_PAYMENT_METHOD.PAY_AT_PLACE, isCheckoutRedesign);

export const BOKADIREKT_GIFTCARD_LIST_ITEM = (isCheckoutRedesign: boolean = false): PaymentMethodListItem =>
  paymentListItem('BOKADIREKT_GIFTCARD_LIST_ITEM', COUPON_PAYMENT_METHOD.GIFTCARD, isCheckoutRedesign);

export const BOKADIREKT_VALUECARD_LIST_ITEM = (isCheckoutRedesign: boolean = false): PaymentMethodListItem =>
  paymentListItem('BOKADIREKT_VALUECARD_LIST_ITEM', COUPON_PAYMENT_METHOD.VALUECARD, isCheckoutRedesign);

export const BOKADIREKT_WELLNESSCARD_LIST_ITEM = (isCheckoutRedesign: boolean = false): PaymentMethodListItem =>
  paymentListItem('BOKADIREKT_WELLNESSCARD_LIST_ITEM', COUPON_PAYMENT_METHOD.WELLNESSCARD, isCheckoutRedesign);

export const SWISH_LIST_ITEM = (isCheckoutRedesign: boolean = false): PaymentMethodListItem =>
  paymentListItem('SWISH_LIST_ITEM', CHECKOUT_PAYMENT_METHOD.SWISH, isCheckoutRedesign);

export const STORED_ONLINE_CARD_LIST_ITEM = (
  isCheckoutRedesign: boolean = false,
  card: PaymentCard,
): PaymentMethodListItem => {
  const baseTranslationKey = getBaseTranslationKey(isCheckoutRedesign);
  return {
    subTitle: _s(`${baseTranslationKey}.STORED_ONLINE_CARD_LIST_ITEM.subTitleOnlinePaymentRequired`),
    type: CHECKOUT_PAYMENT_METHOD.STORED_COF,
    brand: card.brand,
    id: card.id,
    lastFour: card.lastFour,
  };
};

export const COF_PAYMENT_REDIRECT_LOCALSTORAGE_KEY = 'payment-redirect-cof';
